export const PRIVACY_HTML = `<h3>個人情報保護方針（および取扱いについて）</h3>

<p>
  合同会社Co-nnect Inc. (以下、「当社」という。)
  は、マッチングサービス及びそれに付帯する事業を展開しております。
  当社は、当社の事業の用に供する全ての個人情報を適切に取扱うため、当社の全従業者が遵守すべき行動基準として、本方針を定め、その遵守の徹底を図ることといたします。
</p>
<ol>
  <li>
    当社は、個人情報の取扱いに関する法令、国が定める指針その他の規範を遵守します。
    そのため、日本工業規格「個人情報保護マネジメントシステム -
    要求事項」(JIS Q
    15001)に準拠した個人情報保護マネジメントシステムを策定し、適切に運用いたします。
  </li>
  <li>
    当社は、事業の内容及び規模を考慮した適切な個人情報の取得、利用及び提供を行います。
    それには特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行わないこと及びそのための措置を講じることを含みます。
  </li>
  <li>
    当社は、個人情報の取扱いの全部又は一部を委託する場合は、その取扱いを委託された個人情報の安全管理が図られるよう、委託を受けた者に対する必要かつ適切な監督を行います。
  </li>
  <li>
    当社は、本人の同意がある場合又は法令に基づく場合を除き、個人情報を第三者に提供することはありません。
  </li>
  <li>
    当社は、個人情報の漏えい、滅失又はき損の防止及び是正のための措置を講じます。
  </li>
  <li>
    当社は、個人情報の取扱いに関する苦情及び相談への適切かつ迅速な対応に努めます。
    また、当社が保有する開示対象個人情報の開示等の求め(利用目的の通知、開示、訂正・追加又は削除、利用又は提供の停止）を受け付けます。開示等の求めの手続きにつきましては、以下の「個人情報苦情及び相談窓口」までご連絡ください。
  </li>
  <li>
    当社は、個人情報保護マネジメントシステムの継続的改善を行います。
  </li>
</ol>
<div class="bg-white p-24">
  <h5>
    個人情報苦情及び相談窓口
    <br />
    合同会社Co-nnect Inc. 苦情相談窓口
  </h5>

  <dl class="mt-12">
    <div class="flex flex-row gap-8">
      <dt>E-Mail：</dt>
      <dd>support@proffit.jp</dd>
    </div>
    <div class="flex flex-row gap-8">
      <dt>受付時間：</dt>
      <dd>10:00～18:00 ※土日、祝日、年末年始、GW期間は翌営業日以降の対応とさせていただきます。</dd>
    </div>
    <div class="flex flex-row gap-8">
      <dt>制定日：</dt>
      <dd>2017年2月1日</dd>
    </div>
    <div class="flex flex-row gap-8">
      <dt>合同会社：</dt>
      <dd>Co-nnect Inc.</dd>
    </div>
    <div class="flex flex-row gap-8">
      <dt>代表社員：</dt>
      <dd>関根 有</dd>
    </div>
  </dl>
</div>

<h1>個人情報の取扱について</h1>

<h4>1. 個人情報の利用目的</h4>
<ul>
  <li>
    会員登録情報および見込み顧客情報：サービスの提供及びサービス提供に関連するご連絡、及び関連するメール送信のため
  </li>
  <li>
    お問い合わせ情報：当社に頂いたお問い合わせ、ご連絡へのご回答のため
    <ol>
      <li>
        本サービスの改善や新サービスの開発等に役立てるための統計データ作成
      </li>
      <li>
        イベント企画、キャンペーン等の応募又はご登録に伴う確認、連絡、キャンペーンコンテンツの送信又は景品等の送付
      </li>
      <li>
        本サービス画面上に表示する情報、サービス、広告等の利用者の趣味、嗜好等に合わせたカスタマイズ
      </li>
      <li>その他、本サービスの適切な運営</li>
      <li>
        サービスの提供及びサービス提供に関連するご連絡、及び関連するメール送信のため
      </li>
    </ol>
  </li>
</ul>
<small>
  ※なお、個別に利用目的を明示または通知する場合には、その利用目的によるものとします。
</small>

<h4>2. 個人情報の提供</h4>
<ol>
  <li>
    提出いただいた個人情報はご本人の同意なく第三者へ個人情報を提供することはありません。ただし、以下のいずれかに該当する場合は提供をすることがあります。
    <ol>
      <li>
        あらかじめ、本人に必要事項を明示又は通知し、かつ同意頂いた範囲内で、サービス提供のために必要な情報を他の会員に開示する場合
      </li>
      <li>法令に基づく場合</li>
      <li>
        本人ならびに公衆の生命・身体・財産を脅かす可能性がある場合
      </li>
      <li>
        公衆の衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難な場合
      </li>
      <li>
        国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する場合であって、本人の同意を得ることにより当該事務の遂行に支障をきたす場合
      </li>
      <li>
        合併その他の事由による事業の承継が行われる場合で、承継前の利用目的の範囲内で当該個人情報を取扱う場合
      </li>
      <li>
        当社が業務の一部又は全部を他社に委託する場合で当該委託先に開示又は提供する場
        合
      </li>
      <li>
        本サービス画面上に表示する情報、サービス、広告等の利用者の趣味、嗜好等に合わせてカスタマイズする場合で当該カスタマイズのために広告掲載企業等に開示又は提供する場合
      </li>
    </ol>
  </li>
  <li>
    前項第7号乃至第8号に基づいて企業、団体等に開示又は提供された個人情報については、当該企業、団体等が定める個人情報管理に関する規定にしたがって管理されます。
  </li>
  <li>
    利用者が本サービスを利用した場合、本条第1項第1号乃至第8号の開示又は提供につき同意したものとみなされます。
  </li>
</ol>

<h4>3. 当社ウェブサイトにおける個人情報のお取扱い</h4>
<ol>
  <li>
    <h5>アクセスログの利用</h5>

    <p>
      本ウェブサイトではシステム管理のために、利用者のIPアドレス等のアクセスログを収集しています。
      また、ウェブサイトの利用状況を調査するためにもアクセスログを用いています。
      利用者が本ウェブサイトのいずれかのページやシステムにアクセスすると、サーバーが利用者のIPアドレス、ブラウザの種類、アクセス日時等を記録します。
      通常、アクセスログは統計的に処理され、個人情報とリンクすることはいたしません。
      しかし、当社又は他の利用者等の権利、財産やサービス等を保護するため、必要と認められる場合等にはアクセスログを用いて身元の判明を行う場合があります。
    </p>
  </li>
  <li>
    <h5>クッキー（cookie）について</h5>

    <p>
      当社は本ウェブサイトを通じて、利用者のPCに対してクッキーを送信することがあります。
      利用者のPCに設定されたクッキーは、そのPCを識別して利用者の便宜を図る等の目的で使用されます。
      現在の多くのブラウザは、クッキーを受け入れるように初期設定されています。
      利用者はご自身の判断で、クッキーを拒否するように、又はクッキーが送信されていることを表示するようにブラウザを再設定することもできます。
      ただし、クッキーを拒否すると本ウェブサイトの一部が正常に機能しない場合があることにご留意ください。
    </p>
  </li>
  <li>
    <h5>安全性について</h5>

    <p>
      当社は本ウェブサイトのサービスにあたって個人情報の安全性に関して慎重な配慮を心がけています。
      しかしながら、100％安心と断言することはできません。
      当社では、安全性を確保するために常に最大限の努力を続けていきますが、このことはご了承下さい。
      当社の管理下にない外部ウェブサイトが独自に皆様の個人情報を収集する場合があります。
      これらのウェブサイトでは当社が個人情報を管理することはできません。
      相手先ウェブサイトのプライバシーに関する記述等を参考に、利用者個々の判断で対処して下さい。
    </p>
  </li>
</ol>

<h4>4. 開示対象個人情報の取扱い</h4>
<p>
  個人情報の利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去、及び第三者への提供の停止（以下「開示等」という）等、「開示対象個人情報に関する事項の周知」事項につきましては、以下の「個人情報苦情及び相談窓口」までご連絡ください。遅滞なく回答いたします。ご入力頂く情報の提供は任意となっております。ただし、正確な情報をご提供いただけない場合には、ご要望に対応できないことがあります。
</p>

<h4>5. クッキー（cookie）の広告配信利用について</h4>
<p>
  本ウェブサイトでは、ヤフー株式会社をはじめとする第三者から配信される広告が掲載される場合があり、これに関連して、当該第三者が、本ウェブサイトを訪問したユーザーのクッキー情報等を取得し、利用している場合があります。
  <br />
  当該第三者によって取得されたクッキー情報等は、当該第三者のプライバシーポリシーに従って取り扱われます。
  <br />
  ユーザーは、当該第三者のウェブサイト内に設けられたオプトアウトページにアクセスして、当該第三者によるクッキー情報等の広告配信への利用を停止することができます。
  <br />
  クッキーとは、ウェブページを利用したときに、ブラウザーとサーバーとの間で送受信した利用履歴や入力内容などを、お客様のコンピューターにファイルとして保存しておく仕組みです。次回、同じページにアクセスすると、クッキーの情報を使って、ページの運営者はお客様ごとに表示を変えたりすることができます。お客様がブラウザーの設定でクッキーの送受信を許可している場合、ウェブサイトは、ユーザーのブラウザーからクッキーを取得できます。
  <br />
  なお、お客様のブラウザーは、プライバシー保護のため、そのウェブサイトのサーバーが送受信したクッキーのみを送信します。
  <br />
  お客様は、クッキーの送受信に関する設定を「すべてのクッキーを許可する」、「すべてのクッキーを拒否する」、「クッキーを受信したらユーザーに通知する」などから選択できます。設定方法は、ブラウザーにより異なります。クッキーに関する設定方法は、お使いのブラウザーの「ヘルプ」メニューでご確認ください。
  <br />
  すべてのクッキーを拒否する設定を選択されますと、認証が必要なサービスを受けられなくなる等、インターネット上の各種サービスの利用上、制約を受ける場合がありますのでご注意ください。
</p>

<h4>6. 個人情報保護管理者</h4>
<p>合同会社Co-nnect Inc. 代表社員</p>

<h4>7．個人情報苦情及び相談窓口</h4>
<div class="bg-white p-24">
  <p>合同会社Co-nnect Inc. 苦情相談窓口</p>
  <ul class="mt-8">
    <li>E-Mail : support@proffit.jp</li>
    <li>受付時間 : 10:00～18:00</li>
  </ul>
  <p class="mt-8">
    <small>
      ※土日、祝日、年末年始、GW期間は翌営業日以降の対応とさせていただきます。
    </small>
  </p>
</div>`;
